// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"c7f0fda8c78e5a42a623","225":"9a538d2a2bddaad9f500","752":"e6484ca7b53168948b9c"}[chunkId] + ".js";
};